import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { PrismicData, PrismicDataResponse } from '@app-model/api';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { LOAD_PRISMIC_DATA } from './prismic.actions';
import { PrismicService } from './prismic.service';
import * as PrismicActions from '../../store/prismic/prismic.actions';

@Injectable()
export class PrismicEffects {
  private actions$ = inject(Actions);
  private prismicService = inject(PrismicService);


  getPrismicData$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_PRISMIC_DATA),
      switchMap(() =>
        this.prismicService.getPrismicData().pipe(
          tap((response: PrismicDataResponse) => {
            if (!response.results.length) {
              throw { statusText: 'Empty results' };
            }
          }),
          map((response: PrismicDataResponse) => response.results[0].data),
          map((data: PrismicData) => ({ type: PrismicActions.LOAD_PRISMIC_DATA_SUCCESS, payload: { data } })),
          catchError((error) => of({ type: PrismicActions.LOAD_PRISMIC_DATA_FAILURE, payload: { error: error.statusText } })),
        ),
      ),
    ),
  );
}
